<template>
    <div class="popup popup--vue" v-bind:class="{'is-active': show}" @click.stop="cancel">
        <div class="popup__content" @click.stop="cancel">
            <div class="popup__header" @click.stop="">
                <div class="title-3">{{$t('components.ProductTypeImage.howToMessureCorrectly')}}</div>
                <button @click="cancel" class="popup__close" aria-label="{{$t('common.close')}}"></button>
            </div>
            <div class="popup__body py-8 text-center" @click.stop="">
                <img alt class="img-fluid" :src="src" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['show', 'typeCode'],
        computed: {
            src() {
                const lang = document.documentElement.lang || 'cs';

                if(this.typeCode === 'bathrobe') {
                    return '/images/foto/measure/zupan-'+ lang +'.png';
                }

                return '/images/foto/measure/mereni-'+ lang +'.png';
            }
        },
        watch: {
            show: function(newVal) {
                if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
        methods: {
            cancel() {
                if (this.show) {
                    this.$emit('cancel');
                }
            },
            confirm() {
                this.$emit('confirm');
            }
        }
    };
</script>
